import React from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import OfflineDeviceChart from "./Dashboard/OfflineDeviceChart";

const classes = {
    title: {
        "&.MuiTypography-h1": {
            color: "#1C4E80",
            marginTop: "2px",
            marginLeft: "25px",
            marginBottom: "15px",
            fontSize: 25,
            fontWeight: 300,
        },
    },
    backgroundOfflineDevices: {
        backgroundColor: "transparent",
        height: "auto",
        marginBottom: "10px",
        borderRadius: "20px",
        boxShadow: "none",
    },
    background: {
        alignContent: "center",
        height: "auto",
        marginBottom: "10px",
        borderRadius: "20px",
        backgroundColor: "white",
        boxShadow: "#CDCDCD 0px 2px 10px",
    },
    container: {
        paddingTop: "15px",
        align: "left",
        backgroundColor: "transparent",
    },
};

export default function Dashboard() {
    return (
        <>
            <Box component={Grid} item sx={classes.container} data-testid="dashboard-container">
                <Typography variant="h1" sx={classes.title}>
                    Online Devices
                </Typography>
                <OfflineDeviceChart />
            </Box>
            {/*
        <Grid item sx={classes.container}>
            <Box component={Grid} item>
                <Card sx={classes.background}>
                 <DeviceHealthHistoryChart></DeviceHealthHistoryChart> 
                </Card>
            </Box>
        </Grid>
        */}
        </>
    );
}
